import videojs from 'video.js';

export class PollNotificationPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const { playerExtensions } = presentationData;
    return playerExtensions?.some(ext => ext.ExtensionType === 'Mediasite.Player.PollNotification');
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;
    const { playerExtensions } = presentationData;
    const pollNotificationConfig = playerExtensions?.find(ext => ext.ExtensionType === 'Mediasite.Player.PollNotification');

    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('pollNotification')) {
            const { PollNotificationPlugin } = await import(/* webpackChunkName: 'poll-notification' */ './poll-notification.js');
            player.registerPlugin('pollNotification', PollNotificationPlugin);
        }
    }
}
